import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { userShare } from '@/api';
import Report from '@/components/Report';
import Logo from '@/assets/images/share/logo.png';
import './style.less';

@withRouter
class ShareReport extends React.Component {
  static propTypes = {
    match: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      params: null,
      reportData: null,
    };
    this.work = React.createRef();
  }

  componentDidMount() {
    this.setState({ params: this.props.match ? this.props.match.params : null }, () => {
      this.getUserShare();
    });
  }

  getUserShare = async () => {
    const { params } = this.state;
    const result = await userShare.list(params.shareId, params.id, params.attempt);
    this.init(result.data);
  };

  init = (list) => {
    this.setState({ reportData: JSON.parse(list[0].share_diamonds.replace(/[\\]/g, '')) });
  }

  render() {
    return (
      <div className="share-report-container">
        <div className="share-report">
          <div className="share-report-wrapper">
            <div className="share-report-header">
              <img src={Logo} alt="" />
            </div>
            <Report data={this.state.reportData} />
            <div className="share-pic">
              <div className="text">Reading is so fun! Join Rise Online Library!</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShareReport;
